export type AddressFieldErrors = Partial<Record<string, string>>;

const ERROR_FIELD_ALIASES: Record<string, string[]> = {
  postcode: ['zip'],
  houseNumber: ['street'],
  stationNumber: ['stationNumber', 'pickupLocation']
};

function getErrorFieldNames(fieldErrors: AddressFieldErrors) {
  return new Set(Object.keys(fieldErrors).flatMap(fieldName => ERROR_FIELD_ALIASES[fieldName] ?? [fieldName]));
}

function isVisibleAndEditable(element: HTMLElement, fieldName: string) {
  if (element instanceof HTMLInputElement && element.type === 'hidden') {
    return false;
  }

  if (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement
  ) {
    const isReadOnly =
      (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) &&
      element.readOnly &&
      fieldName !== 'pickupLocation';

    return !element.disabled && !isReadOnly;
  }

  return true;
}

/** Scrolls to the first visible form field that has a validation error. */
export function scrollToError(
  container: HTMLElement,
  fieldErrors: AddressFieldErrors = {},
  fieldNamePrefix = ''
): HTMLElement | null {
  const errorFieldNames = getErrorFieldNames(fieldErrors);
  const errorField = Array.from(container.querySelectorAll<HTMLElement>('[name]')).find(element => {
    const elementName = element.getAttribute('name');

    if (!elementName?.startsWith(fieldNamePrefix)) {
      return false;
    }

    const fieldName = elementName.slice(fieldNamePrefix.length);

    return errorFieldNames.has(fieldName) && isVisibleAndEditable(element, fieldName);
  });

  if (!errorField) {
    return null;
  }

  const scrollTarget = errorField.closest<HTMLElement>('.input-outer-container') ?? errorField;

  if (typeof scrollTarget.scrollIntoView === 'function') {
    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  return scrollTarget;
}
